import { NovelSetting } from "@/lib/models/novel";
import {
  genre as genreList,
  category as categoryList,
  workStatus as workStatusList,
  sort as sortList,
} from "@/lib/novelSettings";

/**
 * 翻訳済みジャンルリストを取得
 * @param t - 翻訳関数 ($t or t from useI18n)
 * @returns 翻訳済みジャンルリスト
 */
export const getTranslatedGenreList = (t: (key: string) => string): NovelSetting[] =>
  genreList.map((item) => ({
    ...item,
    name: t(`common.novelSettings.genre.${item.id}`),
  }));

/**
 * 翻訳済みカテゴリリストを取得
 * @param t - 翻訳関数 ($t or t from useI18n)
 * @returns 翻訳済みカテゴリリスト
 */
export const getTranslatedCategoryList = (t: (key: string) => string): NovelSetting[] =>
  categoryList.map((item) => ({
    ...item,
    name: t(`common.novelSettings.category.${item.id}`),
  }));

/**
 * 翻訳済み制作状況リストを取得
 * @param t - 翻訳関数 ($t or t from useI18n)
 * @returns 翻訳済み制作状況リスト
 */
export const getTranslatedWorkStatusList = (t: (key: string) => string): NovelSetting[] =>
  workStatusList.map((item) => ({
    ...item,
    name: t(`common.novelSettings.workStatus.${item.id}`),
  }));

/**
 * 翻訳済みソートリストを取得
 * @param t - 翻訳関数 ($t or t from useI18n)
 * @returns 翻訳済みソートリスト
 */
export const getTranslatedSortList = (t: (key: string) => string): NovelSetting[] =>
  sortList.map((item) => ({
    ...item,
    name: t(`common.novelSettings.sort.${item.id}`),
  }));

/**
 * IDから翻訳済みジャンル名を取得
 * @param t - 翻訳関数 ($t or t from useI18n)
 * @param id - ジャンルID
 * @returns 翻訳済みジャンル名
 */
export const getTranslatedGenreById = (t: (key: string) => string, id: string) => {
  const genre = genreList.find((item) => item.id === id);
  return genre ? t(`common.novelSettings.genre.${genre.id}`) : "";
};

/**
 * IDから翻訳済みカテゴリ名を取得
 * @param t - 翻訳関数 ($t or t from useI18n)
 * @param id - カテゴリID
 * @returns 翻訳済みカテゴリ名
 */
export const getTranslatedCategoryById = (t: (key: string) => string, id: string) => {
  const category = categoryList.find((item) => item.id === id);
  return category ? t(`common.novelSettings.category.${category.id}`) : "";
};

/**
 * IDから翻訳済み制作状況名を取得
 * @param t - 翻訳関数 ($t or t from useI18n)
 * @param id - 制作状況ID
 * @returns 翻訳済み制作状況名
 */
export const getTranslatedWorkStatusById = (t: (key: string) => string, id: string) => {
  const workStatus = workStatusList.find((item) => item.id === id);
  return workStatus ? t(`common.novelSettings.workStatus.${workStatus.id}`) : "";
};
